import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../../../core/services/dataBean/useDataBean';
import { _TaxScheme, _TaxSchemeValue } from '../../../../../../../../core/services/dataBean/EntityCatalog';
import useModal, { MODAL_md } from '../../../../../../../theme/Component/hooks/useModal';
import { Modal } from '../../../../../../../theme/Component/Modal';
import { toast } from 'react-toastify';
import { PrintJson } from '../../../../../../../theme/Component/PrintJson';



interface Props {
    onChange: any;
    label?: string;
}

const FINANCIAL_TAX = 2;

export const FinancialMovementTax = ({ onChange, label }: Props) => {

    const scheme = useDataBean(_TaxScheme);
    const schemeValue = useDataBean(_TaxSchemeValue);
    const [idScheme, setIDScheme] = useState<number>(null);
    const [idSchemeValue, setIDSchemeValue] = useState<number>(null);
    const [renderValue, setRenderValue] = useState<string>("");

    const modal = useModal("Seleccione el Impuesto y el valor del mismo", MODAL_md)

    useEffect(() => {
        getlista1()
    }, [modal.modal])

    const getlista1 = () => {
        scheme.instance.getTaxSchemeCatalogByType(FINANCIAL_TAX).then(
            (resp) => {
                scheme.setLista(resp)
            }
        ).catch(err => { toast.error(err) })
    }

    useEffect(() => {
        if (idScheme)
            getLista2()
    }, [idScheme])

    const getLista2 = () => {
        schemeValue.instance.getTaxSchemeValueCatalog(idScheme).then(
            (resp) => {
                schemeValue.setLista(resp);
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }



    const selectItem = () => {
        const selectedItem = schemeValue.lista.find(
            (item) => item?.DataBeanProperties?.IDTaxSchemeValue == idSchemeValue
        );

        if (idSchemeValue) {
            setRenderValue(`${selectedItem.DataBeanProperties.IDTaxSchemeValue}-${selectedItem.DataBeanProperties.TaxValueName}`)
            modal.close();
            onChange?.(idSchemeValue)
        } else {
            toast.error("Valor no valido")
        }
    }

    return (
        <>
            <label>{label ? label : 'Gravámenes Financieros'}</label>
            <input
                type="text"
                className="form-control"
                placeholder="Buscar..."
                value={renderValue}
                onClick={() => { modal.open() }}
            />

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { selectItem() }}>
                <div className="row">
                    <div className="col-md-12">
                        <label>Impuesto</label>
                        <select className="form-control" value={idScheme} onChange={(e) => {
                            const value = e.target.value ? Number(e.target.value) : null;
                            setIDScheme(value)
                        }}>
                            <option value={""}>...</option>
                            {scheme.lista &&
                                scheme.lista.map((item: any) => {
                                    return (
                                        <>
                                            <option key={item.DataBeanProperties.IDTaxScheme} value={item.DataBeanProperties.IDTaxScheme} >{item.DataBeanProperties.Name}</option>
                                        </>)
                                })
                            }
                        </select>
                    </div>
                    <div className="col-md-12">
                        <label>Valor del Impuesto</label>
                        <select className="form-control" value={idSchemeValue} onChange={(e) => {
                            const value = e.target.value ? Number(e.target.value) : null;
                            setIDSchemeValue(value)
                        }}>
                            <option value={""}>...</option>
                            {schemeValue.lista &&
                                schemeValue.lista.map((item: any) => {
                                    return (
                                        <>
                                            <option key={item.DataBeanProperties.IDTaxSchemeValue} value={item.DataBeanProperties.IDTaxSchemeValue} >{item.DataBeanProperties.TaxValueName}</option>
                                        </>)
                                })
                            }
                        </select>
                    </div>
                </div>
            </Modal>
        </>
    )
}